import { render, staticRenderFns } from "./ebook_list.vue?vue&type=template&id=b41ffb7a&scoped=true&"
import script from "./ebook_list.vue?vue&type=script&lang=js&"
export * from "./ebook_list.vue?vue&type=script&lang=js&"
import style0 from "./ebook_list.vue?vue&type=style&index=0&id=b41ffb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41ffb7a",
  null
  
)

export default component.exports